import React, { useState } from "react";
import { api } from "@/lib/api";
import { colorOf } from "@/lib/constants";
import { toast } from "sonner";
import { X, Lock } from "lucide-react";

export default function PinDialog({ member, onCancel, onSuccess }) {
  const [pin, setPin] = useState("");
  const [checking, setChecking] = useState(false);
  const color = colorOf(member.color);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pin.length < 1) return;
    setChecking(true);
    try {
      const res = await api.verifyPin(member.id, pin);
      if (res.ok) onSuccess();
      else {
        toast.error("Wrong PIN");
        setPin("");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(20,20,18,0.45)", backdropFilter: "blur(6px)" }}
      onClick={onCancel}
      data-testid="pin-dialog"
    >
      <form
        onSubmit={handleSubmit}
        className="bg-[color:var(--surface)] rounded-xl w-full max-w-sm border border-[color:var(--line)] shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 pt-5 pb-4 flex items-center gap-3 border-b border-[color:var(--line-soft)]">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-xl"
            style={{ background: color.hex }}
          >
            {member.avatar_emoji}
          </div>
          <div className="flex-1">
            <div className="label-tiny flex items-center gap-1">
              <Lock className="w-3 h-3" strokeWidth={2} /> PIN
            </div>
            <h2 className="font-display text-xl">{member.name}</h2>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="ff-btn h-9 w-9 !p-0"
            data-testid="pin-cancel"
            aria-label="Cancel"
          >
            <X className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>

        <div className="p-6">
          <input
            autoFocus
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            placeholder="••••"
            className="w-full border border-[color:var(--line)] rounded-xl px-4 py-4 text-center font-mono text-3xl tracking-[0.5em] focus:outline-none focus:border-[color:var(--ink)]"
            data-testid="pin-input"
          />
          <button
            type="submit"
            disabled={checking || !pin}
            className="ff-btn ff-btn-primary w-full mt-4 disabled:opacity-60"
            data-testid="pin-submit"
          >
            {checking ? "Checking…" : "Unlock"}
          </button>
        </div>
      </form>
    </div>
  );
}
